import { Button, Grid } from '@mui/material'
import { ErrorDialog, MergeDialog, SuccessDialog } from '../../Dialogs'
import React, { useEffect } from 'react'
import searchResultsState, {
  filteredSearchResultsState,
} from '../../atoms/searchResultsState'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import FormControl from '@mui/material/FormControl'
import RadioGroup from '@mui/material/RadioGroup'
import SearchResultCard from './SearchResultCard'
import SearchResultsHeader from './SearchResultsHeader'
import searchParamsState from '../../atoms/searchParamsState'
import styled from 'styled-components'

const EmptyState = styled.h1`
	font-family: 'Roboto', sans-serif;
	font-style: normal;
	font-weight: normal;
	font-size: 1.5rem;
	line-height: 1.5rem;
	color: #000000;
	margin-top: 7rem;
	text-align: center;
	padding-top: 100px;
`

const SearchResults = ({ searchService, mergeService }) => {
  const searchResults = useRecoilValue(searchResultsState)
  const filteredSearchResults = useRecoilValue(filteredSearchResultsState)
  const setSearchResults = useSetRecoilState(searchResultsState)
  const [primaryAccount, setPrimaryAccount] = React.useState(null)
  const [duplicateAccounts, setDuplicateAccounts] = React.useState([])
  const [modalOpen, setModalOpen] = React.useState(false)
  const [showErrorDialog, setShowErrorDialog] = React.useState(false)
  const [showSuccessDialog, setShowSuccessDialog] = React.useState(false)
  const searchParams = useRecoilValue(searchParamsState)

  const updatePrimaryAccount = event => {
    setPrimaryAccount(event.target.value)
    if (duplicateAccounts.includes(event.target.value))
      setDuplicateAccounts(
        duplicateAccounts.filter(e => e !== event.target.value),
      )
  }

  const updateDuplicateAccounts = event => {
    if (duplicateAccounts.includes(event.target.value))
      setDuplicateAccounts(
        duplicateAccounts.filter(e => e !== event.target.value),
      )
    else {
      if (event.target.value !== primaryAccount) {
        setDuplicateAccounts([...duplicateAccounts, event.target.value])
      }
    }
  }

  const doMerge = async () => {
    const result = await mergeService(primaryAccount, duplicateAccounts).catch(
      () => setShowErrorDialog(true),
    )

    if (result.status === 200) {
      setPrimaryAccount(null)
      setDuplicateAccounts([])
      setShowSuccessDialog(true)
      setTimeout(() => setShowSuccessDialog(false), 2000)
      setModalOpen(false)

      const searchResults = await searchService.getAccounts(
        searchParams.firstName,
        searchParams.lastName,
        searchParams.phone,
        searchParams.email,
      )
      if (searchResults && searchResults.length > 0) {
        setSearchResults(searchResults)
      }
    }
  }

  useEffect(() => {
    setPrimaryAccount(null)
    setDuplicateAccounts([])
  }, [searchResults])

  const showModal = event => {
    event.preventDefault()
    setModalOpen(true)
  }

  const searchResultCards = () =>
    filteredSearchResults.map(result => {
      const isSelected = Number(primaryAccount) === result.profileId
      const isChecked = duplicateAccounts.includes(String(result.profileId))
      return (
        <SearchResultCard
          isChecked={isChecked}
          isSelected={isSelected}
          key={result.profileId}
          onChange={updateDuplicateAccounts}
          profile={result}
        />
      )
    })

  return (
    <div>
      {filteredSearchResults === null && (
        <EmptyState>Enter search criteria to see user accounts.</EmptyState>
      )}
      {filteredSearchResults !== null && filteredSearchResults.length === 0 && (
        <EmptyState>
					There were no search results found. Please try again.
        </EmptyState>
      )}

      {filteredSearchResults !== null && filteredSearchResults.length !== 0 && (
        <div>
          <SearchResultsHeader resultCount={filteredSearchResults.length} />

          <FormControl component="fieldset">
            <RadioGroup
              aria-label="primaryAccount"
              name="primaryAccountRadioGroup"
              onChange={updatePrimaryAccount}
              value={primaryAccount}
            >
              {searchResultCards()}
            </RadioGroup>
          </FormControl>
          <Grid container direction="row" justifyContent="flex-end" spacing={1}>
            <Grid align="center" item xs={4}>
              <form onSubmit={showModal}>
                <Button
                  aria-label="Open Merge Confirmation Dialog"
                  color="primary"
                  disabled={
                    primaryAccount && duplicateAccounts.length > 0
                      ? false
                      : true
                  }
                  type="submit"
                  variant="contained"
                >
									MERGE ACCOUNTS
                </Button>
              </form>
            </Grid>
          </Grid>
        </div>
      )}
      <MergeDialog
        merge={doMerge}
        onClose={() => setModalOpen(false)}
        open={modalOpen}
      />
      <ErrorDialog
        message="The merge was unsuccessful"
        onClose={() => setShowErrorDialog(false)}
        open={showErrorDialog}
      />
      <SuccessDialog
        message="The selected accounts were merged successfully"
        onClose={() => setShowSuccessDialog(false)}
        open={showSuccessDialog}
      />
    </div>
  )
}

export default SearchResults
